import { render, staticRenderFns } from "./OwnersDeleteModalController.vue?vue&type=template&id=a68d6316&"
import script from "./OwnersDeleteModalController.vue?vue&type=script&lang=ts&"
export * from "./OwnersDeleteModalController.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports